import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import './LoginPage.css';

export function LoginPage() {
  const { login, loginError } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const displayError = error || loginError;

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError(null);
      await login();
    } catch (err) {
      console.error('Login error in component:', err);
      setError(err instanceof Error ? err.message : 'Login failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="login-container-wrapper">
      <main>
        <div className="login-main-content">
          <div className="login-content-section" aria-label="login content">
            <img
              src="/static/RI_WithoutStrap_RGB.png"
              alt="Rentokil Initial Logo"
              className="login-left-image"
            />
            <div className="login-info-section">
              <div className="login-logo-section">
                <img
                  src="/static/ManageConnect-Logo.svg"
                  alt="ManageConnect Logo"
                  className="login-manage-connect-image"
                />
              </div>
              <div aria-label="logo text container" className="login-logo-text-container">
                <p className="login-logo-text">Manage</p>
                <p className="login-logo-text">Connect</p>
              </div>
            </div>
            <h1 className="login-title">"The Home of IoT"🧪</h1>
            <p className="login-subtitle">
              Use ManageConnect to troubleshoot, find out service
              performance and gain commercial awareness for PestConnect.
            </p>
            <div className="login-actions-section">
              <div className="google-sign-in-wrapper">
                <button
                  id="login-button"
                  className="google-sign-in-button"
                  onClick={() => { void handleLogin(); }}
                  disabled={loading}
                  aria-label="google sign in button"
                  type="button"
                >
                  <div className="google-sign-in-content">
                    <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                    </svg>
                    <span className="google-sign-in-text">
                      {loading ? 'Signing in...' : 'Sign in with Google'}
                    </span>
                  </div>
                </button>
              </div>
              {displayError && (
                <div className="login-error">
                  {displayError}
                </div>
              )}
            </div>
          </div>
          <div className="login-image-section"></div>
        </div>
        
        
        
      </main>
    </div>
  );
}
